import { format } from "date-fns";
import { HotelListType, HotelSearchRoom, HotelType, Room } from "../types/HotelType"
import { httpRequest } from "./httpRequest"

export class HotelAPI {

  constructor(private apiBaseUrl: string) {}

  /** Return first hotel object found for given type, or an empty array if none found” */
  public async get(hotelId: string): Promise<HotelType> {
    try {
      const result = await httpRequest(
        "GET",
        `${this.apiBaseUrl}/hotels/${hotelId}`
      );

      if (result.status === 200) {
        const hotel = await result.json();

        return hotel ? hotel : false;
      }
    } catch (err) {
      console.warn(err);
    }
    return {} as HotelType;
  }

  /** Return all hotels,or an empty array if none found */
  public async getAll(): Promise<HotelListType[]> {
    try {
      // ${this.apiBaseUrl}/hotels?cached=1
      const result = await httpRequest(
        "GET",
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/hotels?resort=588&cached=1`
      );

      if (result.status === 200) {
        const hotels = await result.json();

        return hotels.data.length ? hotels.data : false;
      }
    } catch (err) {
      console.warn(err);
    }

    return [];
  }

  // returns a list of hotels that match the search query
  public async getHotelsSearch( dates: Date[], rooms: HotelSearchRoom[] ): Promise<HotelListType[]> {
    const apiBaseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/hotels?resort=588&cached=1`;
    const hotelSearch: string[] = [];
    const formatedDate = dates.map(date => format(date,'yyyy-MM-dd'))

    if (rooms.length > 0) {
      rooms.map((room: HotelSearchRoom, index: number) => {
        hotelSearch.push(
          `&adults${index === 0 ? "" : index + 1}=${room.adultsQty}&children${
            index === 0 ? "" : index + 1
          }=${room.childrenQty}&infants${index === 0 ? "" : index + 1}=${
            room.infantsQty
          }&child_ages${index === 0 ? "" : index + 1}=${
            room.childrenAges.length > 0 || room.childrenQty != 0
              ? room.childrenAges.map((age: number) => age)
              : 0
          }`
        );
      });

      try {
        const result = await httpRequest('GET',
          `${apiBaseUrl}${hotelSearch.join("")}&date_from=${
            formatedDate[0]
          }&date_to=${formatedDate[1]}`
        );
        if (result.status === 200) {
          const hotels = await result.json();
          return hotels.data;
        }
      } catch (err) {
        console.warn(err);
      }
    }
    return [];
  }

  public async getHotelRoomsAvailability( hotelId: string, dates: Date[], roomsSearch:HotelSearchRoom[] ): Promise<Room[]> {
    //that will chenge whenn we will have ready Hotels api, all API calls will be made with apiBase from .env file
    const apiBaseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/hotels`;

    const hotelRoomSearch: string[] = [];
    const formatedDate = dates.map(date => format(date,'yyyy-MM-dd'));

    roomsSearch.map((room: HotelSearchRoom, index: number) => {
      hotelRoomSearch.push(
        `&adults${index === 0 ? "" : index + 1}=${room.adultsQty}&children${index === 0 ? "" : index + 1
        }=${room.childrenQty}&infants${index === 0 ? "" : index + 1}=${room.infantsQty
        }&child_ages${index === 0 ? "" : index + 1}=${room.childrenAges.length > 0 || room.childrenQty != 0
          ? room.childrenAges.map((age: number) => age)
          : 0
        }`
      );
    });

    try {
      const result = await httpRequest('GET',`${apiBaseUrl}/${hotelId}?resort=588&hotel_id=${hotelId}${hotelRoomSearch.join("")}&date_from=${formatedDate[0]}&date_to=${formatedDate[1]}&cached=1&view=website`);
        const hotelsWithAvailbleRooms = await result.json();
        return hotelsWithAvailbleRooms.rooms;
    } catch (err) {
      console.warn(err);
    }
  return [];
  }
}
